import type { CSSProperties } from 'react';
import { UsageStatus } from '../../../../Constants/VOSS/usageTypes';

interface ColorTokens {
    background: string;
    borderColor: string;
    color: string;
}

const colorsByStatus: Record<UsageStatus, ColorTokens> = {
    [UsageStatus.Ok]: {
        background: 'var(--alert-success-bg)',
        borderColor: 'var(--alert-success-border)',
        color: 'var(--alert-success-text)',
    },
    [UsageStatus.Warning]: {
        background: 'var(--alert-warning-bg)',
        borderColor: 'var(--alert-warning-border)',
        color: 'var(--alert-warning-text)',
    },
    [UsageStatus.Over]: {
        background: 'var(--alert-danger-bg)',
        borderColor: 'var(--alert-danger-border)',
        color: 'var(--alert-danger-text)',
    },
    [UsageStatus.Neutral]: {
        background: 'var(--neutral-10)',
        borderColor: 'var(--neutral-30)',
        color: 'var(--neutral-90)',
    },
};

export const badgeVariantByStatus: Record<UsageStatus, string> = {
    [UsageStatus.Ok]: 'badge-success',
    [UsageStatus.Warning]: 'badge-warning',
    [UsageStatus.Over]: 'badge-danger',
    [UsageStatus.Neutral]: '',
};

// Inner panel style for a usage tile, coloured by status.
export const tileStyle = (status: UsageStatus): CSSProperties => ({
    ...colorsByStatus[status],
    borderWidth: '1px',
    borderStyle: 'solid',
});
